import React, { Component } from 'react';

import {
    withRouter
} from 'react-router-dom';

import {
    // Page,
    Text,
    Button,
    // Select,
    BlockStack,
    Icon,
    RadioButton,

} from '@shopify/polaris';
import {
    ChevronLeftMinor
} from '@shopify/polaris-icons';
import './index.scss';
import {
    reqUpdateLanguage,
    reqSaveSwitchState,

} from '../../../api';
import { connect } from 'react-redux'
import { setSaveSwitchData, changeLanguageInfo } from '../../../redux/actions/getAppPublicData';
import SpeedOptGuide from '../../../assets/Guide/SpeedOptGuide';
import UseSeoantGuide from '../../../assets/Guide/UseSeoantGuide';
import PersonSeoGuide from '../../../assets/Guide/PersonSeoGuide';
import { store } from '../../../redux/store';
// 翻译
import Language from '../../../i18n/Language';
import utils from '../../../utils/utils';
import cloneDeep from 'lodash-es/cloneDeep';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language;

class Settings extends Component {
    state = {
        pageIndex: 0, // 页面索引
        curId: 0,
        Language: 'en',
        loadingSwitch: false,
        nextLoading: false,
        meanValue: 1
    }

    componentDidMount() {

    }

    // 切换图片
    changeAreasItem = (inx) => {
        this.setState({
            curId: inx
        })
    }

    // 跳转价格页
    jumpPricing = () => {
        this.setState({
            nextLoading: true,
        }, () => {
            this.requestStateSet('beginner_in_seo', Number(this.state.meanValue));
        })
    }

    // 选择语言
    changeLanguage = (val) => {
        this.setState({
            Language: val,
            loadingSwitch: true,
        }, async () => {
            // 修改缓存
            window.language = val;
            this.props.changeLanguageStatus(val); //缓存全局状态
            const params = {
                Language: val,
            };
            const res = await reqUpdateLanguage(params)
            if (res.code === 200) {
                this.props.toggleToast(t("Success"), false)
                this.setState({
                    loadingSwitch: false,
                })
            } else {
                this.props.toggleToast(res.msg, true)
                this.setState({
                    loadingSwitch: false,
                })
            }
        })
    }

    // 选择选项
    changeSelectValue = (val) => {
        this.setState({
            meanValue: val
        })
    }

    // 发送请求
    requestStateSet = async (type, state) => {
        const params = {
            name: `${type}`,
            st: Number(state),
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            // this.props.toggleToast('Succeed', false);
            let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data);
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 1, "exp": 0 };
            if (type === 'beginner_in_seo') {
                data[`newbie_guide_page`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 1, "exp": 0 };
            }
            this.props.setSwitchData(data);
            utils.routeJump(this, "/plan", null, 'guide');
        } else {
            this.props.toggleToast(t("Try again later"), true);
        }

        return res;
    }

    render() {
        const {
            pageIndex,
            // curId,
            // Language,
            loadingSwitch,
            nextLoading,
            meanValue,

        } = this.state;

        // const _info = this.props.public.Language; // 缓存语言

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 语言 地球图标
        // const wordIcon = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path fillRule="evenodd" clipRule="evenodd" d="M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 8.75814 2.32494 10.3236 3.60886 11.3304L4.25042 10.6889C5.21106 9.72825 6.70763 9.55781 7.85968 10.2778C8.04597 10.3943 8.26922 10.4364 8.48513 10.3959L11.7438 9.78493C12.2244 8.96811 12.5 8.01624 12.5 7C12.5 6.73705 12.4815 6.47841 12.4459 6.2253L12.4283 6.23114C12.3219 6.26664 12.25 6.36628 12.25 6.47851L12.25 7.24999C12.25 8.35456 11.3546 9.25 10.25 9.25C9.49063 9.25 8.87502 8.63439 8.87502 7.87499V7.5C8.87502 7.36193 8.76309 7.25 8.62502 7.25L8.11809 7.24999C7.71697 7.25 7.35027 7.47663 7.17089 7.83541L7.04818 8.08082C6.68991 8.79737 5.95754 9.25 5.15642 9.25C4.12251 9.25 3.24014 8.50253 3.07015 7.4827L3.01134 7.12983C2.80605 5.89824 3.52727 4.70034 4.71178 4.30551L5.4613 4.05567C5.63372 3.99819 5.75003 3.83684 5.75003 3.65509C5.75004 2.89911 6.19314 2.21334 6.88233 1.90267L7.68258 1.54194C7.45894 1.51426 7.23113 1.5 7 1.5ZM9.76895 2.24682L7.49876 3.27016C7.34737 3.3384 7.25003 3.48904 7.25003 3.65511C7.25002 4.4825 6.72057 5.21705 5.93564 5.47869L5.18612 5.72853C4.70185 5.88995 4.407 6.37969 4.49092 6.88321L4.54974 7.23608C4.59917 7.53264 4.85576 7.75 5.15642 7.75C5.38938 7.75 5.60235 7.61838 5.70654 7.41001L5.82924 7.16459C6.26272 6.29764 7.1488 5.75 8.11808 5.75L8.62502 5.75C9.59152 5.75 10.375 6.5335 10.375 7.5V7.73425C10.5907 7.67875 10.75 7.48298 10.75 7.24999L10.75 6.47851C10.75 5.72062 11.235 5.04778 11.954 4.80812L12.0342 4.78139C11.5643 3.71673 10.7666 2.82923 9.76895 2.24682ZM7 12.5C6.27686 12.5 5.58632 12.3604 4.95384 12.1068L5.31108 11.7496C5.77782 11.2828 6.50494 11.2 7.06468 11.5498C7.57009 11.8657 8.17577 11.9801 8.76157 11.8702L9.93958 11.6494C9.08929 12.1881 8.08107 12.5 7 12.5Z" fill="#4A4A4A" />
        // </svg>

        // 最终内容
        const pageContent = 1 ? <div className='new_guide_main'>
            <title>SEOAnt - Guide</title>
            <div className='new_guide_box'>
                <div className='guide_item guide_left'>
                    <img src='/Image/guide_bg.png' alt='' className='guide_bg' />
                    <span className='guide_icon'><Icon source={pageIndex === 0 ? SpeedOptGuide : pageIndex === 1 ? UseSeoantGuide : PersonSeoGuide} /></span>
                </div>
                <div className='guide_item guide_right'>
                    <div className='gr_content'>
                        <BlockStack gap={800}>
                            <div className='gr_title'>
                                <Text variant="headingSm" as="h3">{t("Step {{v1}} of {{v2}}", pageIndex + 1, 3)}</Text>
                                {
                                    pageIndex === 0 ? <Text variant="headingXl" as="h2">{t("Welcome to SEOAnt!")} 👋</Text> :
                                        pageIndex === 1 ? <Text variant="headingXl" as="h2">{t("Using SEOAnt, what will you gain?")}</Text> :
                                            <Text variant="headingXl" as="h2">{t("Personalize your seo experience")}</Text>
                                }
                            </div>
                            {
                                pageIndex === 0 ? <div className='all_text'>
                                    <p className='keypoint_text'>{t("Say goodbye to the confusion of website optimization.SEOAnt will easily help you solve SEO challenges, improve your website ranking and traffic, making your online business more competitive!")}</p>
                                    <p className='desc_text'>{t("Covers all SEO features, including speed optimization, 404 error fixing, search result optimization, keyword research, and more.")}</p>
                                </div> : pageIndex === 1 ? <div className='all_text_point'>
                                    <p>{t("Comprehensive solution to website SEO problems")}</p>
                                    <p>{t("Faster website loading speeds")}</p>
                                    <p>{t("Higher quality website content")}</p>
                                </div> : <div className='all_text'>
                                    <p className='desc_text radio_block'>{t("Let us know your experience level so we can guide you better.")}</p>
                                    <BlockStack gap={400}>
                                        <RadioButton
                                            label={t("Yes, I'm a beginner in SEO")}
                                            checked={meanValue === 1}
                                            id="YesVal"
                                            name="YesVal"
                                            onChange={() => this.changeSelectValue(1)}
                                        />
                                        <RadioButton
                                            label={t("No, I have some experience")}
                                            id="NoVal"
                                            name="NoVal"
                                            checked={meanValue === 0}
                                            onChange={() => this.changeSelectValue(0)}
                                        />
                                    </BlockStack>
                                </div>
                            }
                            {
                                pageIndex === 0 ? <BlockStack gap={300}>
                                    {/* <Select
                                        options={[
                                            {
                                                value: 'en',
                                                label: "English",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'pt',
                                                label: "Português",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'fr',
                                                label: "Française",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'ge',
                                                label: "Deutsch",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'it',
                                                label: "Italian",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'sp',
                                                label: "Español",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'dut',
                                                label: "Nederlands",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'in',
                                                label: "India",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'se',
                                                label: "Svenska",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'jp',
                                                label: "にほんご",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'zh_hant',
                                                label: "中文繁体",
                                                prefix: wordIcon
                                            },
                                            {
                                                value: 'zh',
                                                label: "中文简体",
                                                prefix: wordIcon
                                            }
                                        ]}
                                        value={Boolean(_info) ? _info : Language}
                                        onChange={this.changeLanguage}
                                        disabled={loadingSwitch}
                                    /> */}
                                    <Button variant='primary' size='large' fullWidth loading={loadingSwitch} onClick={() => {
                                        this.setState({ pageIndex: 1 })
                                    }}>
                                        <div className='flex_layout'>
                                            <span>{t("Let's get started")}</span>
                                            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M0.499512 5C0.499512 4.58579 0.835298 4.25 1.24951 4.25L10.9391 4.25L8.21921 1.53036C7.9263 1.23748 7.92628 0.762605 8.21915 0.469697C8.51203 0.176788 8.98691 0.176764 9.27981 0.469644L13.2802 4.46964C13.4209 4.6103 13.4999 4.80107 13.4999 5C13.4999 5.19893 13.4209 5.3897 13.2802 5.53036L9.27981 9.53036C8.98691 9.82324 8.51203 9.82321 8.21915 9.5303C7.92628 9.2374 7.9263 8.76252 8.21921 8.46964L10.9391 5.75L1.24951 5.75C0.835298 5.75 0.499512 5.41421 0.499512 5Z" fill="white" />
                                            </svg>
                                        </div>
                                    </Button>
                                </BlockStack> :
                                    pageIndex === 1 ? <BlockStack gap={300}>
                                        <Button variant='primary' size='large' fullWidth loading={loadingSwitch} onClick={() => {
                                            this.setState({ pageIndex: 2 })
                                        }}>
                                            <div className='flex_layout'>
                                                <span>{t("Continue")}</span>
                                                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.499512 5C0.499512 4.58579 0.835298 4.25 1.24951 4.25L10.9391 4.25L8.21921 1.53036C7.9263 1.23748 7.92628 0.762605 8.21915 0.469697C8.51203 0.176788 8.98691 0.176764 9.27981 0.469644L13.2802 4.46964C13.4209 4.6103 13.4999 4.80107 13.4999 5C13.4999 5.19893 13.4209 5.3897 13.2802 5.53036L9.27981 9.53036C8.98691 9.82324 8.51203 9.82321 8.21915 9.5303C7.92628 9.2374 7.9263 8.76252 8.21921 8.46964L10.9391 5.75L1.24951 5.75C0.835298 5.75 0.499512 5.41421 0.499512 5Z" fill="white" />
                                                </svg>
                                            </div>
                                        </Button>
                                    </BlockStack> : <BlockStack gap={300}>
                                        <Button variant='primary' size='large' fullWidth loading={nextLoading} onClick={this.jumpPricing}>
                                            <div className='flex_layout'>
                                                <span>{t("Start exploring")}</span>
                                                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.499512 5C0.499512 4.58579 0.835298 4.25 1.24951 4.25L10.9391 4.25L8.21921 1.53036C7.9263 1.23748 7.92628 0.762605 8.21915 0.469697C8.51203 0.176788 8.98691 0.176764 9.27981 0.469644L13.2802 4.46964C13.4209 4.6103 13.4999 4.80107 13.4999 5C13.4999 5.19893 13.4209 5.3897 13.2802 5.53036L9.27981 9.53036C8.98691 9.82324 8.51203 9.82321 8.21915 9.5303C7.92628 9.2374 7.9263 8.76252 8.21921 8.46964L10.9391 5.75L1.24951 5.75C0.835298 5.75 0.499512 5.41421 0.499512 5Z" fill="white" />
                                                </svg>
                                            </div>
                                        </Button>
                                    </BlockStack>
                            }
                            {
                                [1, 2].includes(pageIndex) ? <div className='goUp_step flex_layout' onClick={() => {
                                    this.setState({ pageIndex: pageIndex - 1 })
                                }}>
                                    <Icon tone='base' source={ChevronLeftMinor} />
                                    {t("Back")}
                                </div> : null
                            }
                        </BlockStack>
                    </div>
                </div>
            </div>

            {/* 底部 */}
            {FooterHelpBox}

        </div> : null;

        return pageContent;
    }
}

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

    // 修改语言状态
    changeLanguageStatus(val) {
        dispatch(changeLanguageInfo(val));
    },
})

Settings = connect(
    mapStateToProps,
    mapDispatchToProps
)(Settings);

export default withRouter(Settings);